<template>
  <page-status class="proposal-sign" :loading="loading">
    <van-cell-group>
      <van-cell>
        <cell-header slot="title" title="投保承诺书" />
      </van-cell>
      <div class="viewer-content">
        <pdf-viewer :url="clauseUrl" />
      </div>
    </van-cell-group>

    <div class="sign-container">
      <div class="sign-actions">
        <van-button class="button" type="info" @click="toNextPage()">
          去认证签名
        </van-button>
      </div>
    </div>
    <page-footer />
  </page-status>
</template>

<script>
import { Toast } from 'vant';
import VueSignaturePad from 'vue-signature-pad';
import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import PdfViewer from '@/components/PdfViewer';
import * as services from '@/services';
import * as cache from '@/utils/cache';
import { bindRecord } from '@/core/recorder';

export default {
  name: 'InsureSignNew',
  components: {
    PageStatus,
    CellHeader,
    PageFooter,
    PdfViewer,
  },

  data() {
    return {
      loading: false,
      clauseUrl: '',
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },
  activated() {
    this.$refs.signaturePad && this.$refs.signaturePad.resizeCanvas();
  },

  methods: {
    fetchData() {
      const { businessNo, mobile } = this.$route.query;

      // 绑定用户
      if (businessNo && mobile) {
        bindRecord({ userId: businessNo + '_' + mobile });
      }

      const clause = {
        bizType: 'printProposal',
        businessNo,
        clauseModelNo: '1102459',
        comCode: '',
      };
      this.clauseUrl = services.getMotorProposalLink(clause, mobile); //获取协议书模版
    },

    toNextPage() {
      const { query } = this.$route;
      const params = {
        ...query,
      };

      this.$router.push({ path: '/auth-signature', query: params });
    },
  },
};
</script>

<style lang="less">
.proposal-sign {
  width: 100%;
  height: 100%;
  padding-top: 12px;
  box-sizing: border-box;

  .clause.active {
    color: #108ee9;
  }

  .agreement {
    padding: 12px;
    font-size: 14px;
  }

  .sign-container {
    padding: 12px;
  }

  .sign-content {
    background-color: #fafafa;
    border: 1px solid #dcdcdc;
    border-radius: 4px;
  }

  .sign-actions {
    margin-top: 12px;
    text-align: center;
    display: flex;

    .button {
      flex: 1;
      border-radius: 4px;

      & + .button {
        margin-left: 12px;
      }
    }
  }

  .dialog-content {
    padding: 12px 24px;
    font-size: 14px;
    color: #030303;
    text-align: center;
  }

  .viewer-content {
    height: 100%;
    overflow: auto;
    background-color: #f9f9f9;
    width: 100%;
  }
  .viewer-footer {
    position: fixed;
    bottom: 0;
    height: 60px;
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    button {
      width: 100%;
    }
  }
}
</style>
